import { BoxProps } from '@mui/material'
import cn from 'classnames'
import { Box } from 'components/Material/index'
import { useEffect } from 'react'

type SidebarBodyProps = BoxProps & {
  children: React.ReactNode
  className?: string
  autoErrorScroll?: boolean
  errors?: Record<string, any>
}

export const SidebarBody = ({
  children,
  className,
  autoErrorScroll = false,
  errors = {},
  ...rest
}: SidebarBodyProps) => {
  useEffect(() => {
    if (autoErrorScroll && Object.keys(errors).length > 0) {
      const firstErrorKey = Object.keys(errors)[0]
      const errorElement = document.querySelector(`[name="${firstErrorKey}"]`)
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    }
  }, [errors, autoErrorScroll])

  return (
    <Box className={cn('relative', className, 'w-full overflow-auto')} {...rest}>
      {children}
    </Box>
  )
}
